import { gql } from '@apollo/client';
import { CurrencyFragment } from '../fragments/CurrencyFragment';
/**
 * @const CurrenciesQuery
 * @since 1.0.0
 */
export const CurrenciesQuery = gql `
  query CurrenciesQuery($input: CurrenciesInput) {
    currencies(input: $input) {
      ...CurrencyFragment
    }
  }

  ${CurrencyFragment}
`;
